import { render, staticRenderFns } from "./ChzzkChattingShortPanel.vue?vue&type=template&id=3900fc7f&scoped=true"
import script from "./ChzzkChattingShortPanel.vue?vue&type=script&lang=js"
export * from "./ChzzkChattingShortPanel.vue?vue&type=script&lang=js"
import style0 from "./ChzzkChattingShortPanel.css?vue&type=style&index=0&id=3900fc7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900fc7f",
  null
  
)

export default component.exports